import { render, staticRenderFns } from "./Estimage.vue?vue&type=template&id=607308bc&scoped=true"
import script from "./Estimage.vue?vue&type=script&lang=js"
export * from "./Estimage.vue?vue&type=script&lang=js"
import style0 from "./Estimage.vue?vue&type=style&index=0&id=607308bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607308bc",
  null
  
)

export default component.exports